<p-fieldset [legend]="'orders.setup.orderSummary.primaryContact' | translate" id="primary-contact-field">
    @if (isLoading) {
        <app-loader></app-loader>
    } @else if (primaryContact) {
        <div id="primary-contact-field-content">
            <label id="primary-contact-account-owner-label" for="primary-contact-account-owner-value">
                {{ 'orders.accountOwner' | translate }}
            </label>
            <app-ellipsis-tooltip paragraphId="primary-contact-account-owner-value">
                {{ primaryContact.accountOwner }}
            </app-ellipsis-tooltip>

            <label id="primary-contact-organization-label" for="primary-contact-organization-value">
                {{ 'organization' | translate }}
            </label>
            <app-ellipsis-tooltip paragraphId="primary-contact-organization-value">
                {{ primaryContact.organization }}
            </app-ellipsis-tooltip>

            <label id="primary-contact-email-address-label" for="primary-contact-email-address-value">
                {{ 'emailAddress' | translate }}
            </label>
            <app-ellipsis-tooltip paragraphId="primary-contact-email-address-value">
                {{ primaryContact.emailAddress }}
            </app-ellipsis-tooltip>
            <label id="primary-contact-laboratory-label" for="primary-contact-laboratory-value">
                {{ 'laboratory' | translate }}
            </label>
            <app-ellipsis-tooltip paragraphId="primary-contact-laboratory-value">
                {{ primaryContact.laboratory ?? '-' }}
            </app-ellipsis-tooltip>
        </div>
    } @else {
        <div id="empty-state-container">
            <i class="fa-duotone fa-solid fa-magnifying-glass"></i>
            <p>{{ 'orders.selectRequester.emptyState' | translate }}</p>
        </div>
    }
</p-fieldset>
